<script>
import adminTable from './mixins/adminTable'
export default
{

    mixins: [ adminTable ],

    data()
    {
        return {
            data: [],
            url: '/v1/admin/routes',
            tableName: 'tableRoutes',
            emptyModel: { name:null },
            columns: [ 'id', 'name', 'created_at', 'actions'],
            options: {
                headings: {
                    name: this.$t('MENUS.NAME'),
                    actions: this.$t('TABLE.ACTIONS'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                },
                perPage: 50,
                perPageValues: [10, 25, 50, 100, 200, 400],
                saveState: true,
                highlightMatches: true,
                filterByColumn: true,
                columnsDropdown: true,
                toMomentFormat: true,
            }
        }
    },
}
</script>

<template>
    <div class="container-fluid">
        <mv-modal ref="form">
            <span slot="header">{{ $t('GENERAL.EDIT') }}</span>
            <mv-route-form :model="model" :edit="formEdit" @save="saveForm"></mv-route-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('GENERAL.ROUTES') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>


// WEBPACK FOOTER //
// src/pages/Routes.vue